import './App.scss';
import { Home } from './pages/Home';
import {Routes, Route} from 'react-router-dom';
import About from './pages/About/About';
import { Services } from './pages/Services';
import Prices from './pages/Prices/Prices';
import Contactus from './pages/Contact/Contact';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {HelmetProvider} from 'react-helmet-async';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <>
      <HelmetProvider>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/o-nas" element={<About />} />
      <Route path="/oferta" element={<Services />} />
      <Route path="/cennik" element={<Prices />} />
      <Route path="/kontakt" element={<Contactus />} />
        </Routes>
        </HelmetProvider>
    </>
  );
}

export default App;
